// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/reeniebeanie-regular-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/roboto-variablefont_wdthwght-webfont.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
---------------
CSS Reset https://www.joshwcomeau.com/css/custom-css-reset/
---------------
*/

/* 1. Use a more-intuitive box-sizing model */
*,
*::before,
*::after {
  box-sizing: border-box;
}

/* 2. Remove default margin */
*:not(dialog) {
  margin: 0;
}

/* 3. Enable keyword animations */
@media (prefers-reduced-motion: no-preference) {
  html {
    interpolate-size: allow-keywords;
  }
}

body {
  /* 4. Add accessible line-height */
  line-height: 1.5;
  /* 5. Improve text rendering */
  -webkit-font-smoothing: antialiased;
}

/* 6. Improve media defaults */
img,
picture,
video,
canvas,
svg {
  display: block;
  max-width: 100%;
}

/* 7. Inherit fonts for form controls */
input,
button,
textarea,
select {
  font: inherit;
}

/* 8. Avoid text overflows */
p,
h1,
h2,
h3,
h4,
h5,
h6 {
  overflow-wrap: break-word;
}

/* 9. Improve line wrapping */
p {
  text-wrap: pretty;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  text-wrap: balance;
}

/*
  10. Create a root stacking context
*/
#root,
#__next {
  isolation: isolate;
}

li {
  list-style-type: none;
}

a {
  text-decoration: none;
}

/*
---------------
Font size variables
---------------
*/

/* @link https://utopia.fyi/type/calculator?c=320,16,1.2,1728,20,1.25,5,2,&s=0.75|0.5|0.25,1.5|2|3|4|6,s-l&g=s,l,xl,12 */
:root {
  /* Step -2: 11.1111px → 12.8px */
  --step--2: clamp(0.6944rem, 0.6705rem + 0.1199vw, 0.8rem);
  /* Step -1: 13.3333px → 16px */
  --step--1: clamp(0.8333rem, 0.7955rem + 0.1894vw, 1rem);
  /* Step 0: 16px → 20px */
  --step-0: clamp(1rem, 0.9432rem + 0.2841vw, 1.25rem);
  /* Step 1: 19.2px → 25px */
  --step-1: clamp(1.2rem, 1.1176rem + 0.4119vw, 1.5625rem);
  /* Step 2: 23.04px → 31.25px */
  --step-2: clamp(1.44rem, 1.3234rem + 0.5831vw, 1.9531rem);
  /* Step 3: 27.648px → 39.0625px */
  --step-3: clamp(1.728rem, 1.5659rem + 0.8107vw, 2.4414rem);
  /* Step 4: 33.1776px → 48.8281px */
  --step-4: clamp(2.0736rem, 1.8513rem + 1.1115vw, 3.0518rem);
  /* Step 5: 39.8131px → 61.0352px */
  --step-5: clamp(2.4883rem, 2.1869rem + 1.5072vw, 3.8147rem);
  /* Step 6: 47.7757px → 76.2939px */
  --step-6: clamp(2.986rem, 2.5809rem + 2.0254vw, 4.7684rem);
}

/*
---------------
Font
---------------
*/

/*! Generated by Font Squirrel (https://www.fontsquirrel.com) on October 7, 2025 */

@font-face {
  font-family: 'reenie_beanieregular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'robotoregular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
    format('woff2');
  font-weight: normal;
  font-style: normal;
}

/*
---------------
Layout 
---------------
*/

body {
  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-template-rows: auto 1fr auto;
  min-height: 100vh;
  max-width: 100vw;

  font-family: 'robotoregular', sans-serif;
  font-size: var(--step-0);
}

/* main heading */

.main-heading-container {
  grid-column: span 2;

  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;

  background: #7189ff;
  box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.4);
}

.main-heading-and-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
}

.main-heading-container h1 {
  font-family: 'reenie_beanieregular', sans-serif;
  font-size: var(--step-6);
  font-weight: 500;
  text-align: center;
}

.main-heading-container .list-icon {
  width: 100px;
}

/*
---------------
Navigation
---------------
*/

/* hamburger on main heading */

.navbar-toggle {
  display: none;
  background: transparent;
  padding: 10px;
  border: none;
  cursor: pointer;
}

.bar {
  display: block;
  width: 25px;
  height: 3px;
  margin: 5px auto;

  background-color: #111;
  transition: all 0.3 ease-in-out;
}

/* nav on left side */

nav {
  padding: 2rem;

  background: #624cab;
  color: #fff;
}

nav h2 {
  font-size: var(--step-2);
  font-weight: 500;

  border-bottom: 2px solid #fff;
}

.add-todo-icon-and-btn,
.add-project-icon-and-btn {
  margin: 1.25rem 0;
}

.add-todo-btn,
.add-project-btn {
  font-size: var(--step-1);
  font-weight: 700;
}

.nav-project-heading {
  margin-top: 4rem;
}

nav .feather-icon {
  width: 32px;
  height: 32px;
}

.feather-icon {
  cursor: pointer;
}

nav button {
  background: transparent;
  border: none;
  color: #fff;
  cursor: pointer;
}

nav li {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0.25rem 0;
  padding: 0.5rem 1rem;
  width: max-content;

  border-radius: 30px;
}

nav li:hover {
  background-color: #7189ff;
  box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.4);
}

.add-todo-icon-and-btn:hover,
.add-project-icon-and-btn:hover {
  background-color: #d81159;
}

.active-btn-container.active {
  background-color: #7189ff;
  box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.4);
}

/*
---------------
Todos Content
---------------
*/

.category-heading {
  margin: 3rem 0;
  text-align: center;
  font-size: var(--step-4);

  color: #624cab;
}

.project-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  margin: 3rem 0 2rem 0;

  font-family: 'reenie_beanieregular', sans-serif;
}

.project-heading {
  font-size: var(--step-4);
  font-weight: 500;
}

.todo-container {
  display: grid;
  grid-template-columns: auto 1fr auto auto;
  align-items: center;
  gap: 2rem;
  padding: 1rem 2rem;

  border-bottom: 2px solid #a0ddff;
}

.todo-icons-container,
.project-header-icons-container {
  display: flex;
  gap: 0.5rem;
}

.completed {
  color: #c1cefe;
  text-decoration: line-through;
}

input[type='checkbox'] {
  appearance: none;
  color: currentColor;
  width: 1.5em;
  height: 1.5em;
  border: 0.15em solid currentColor;
  border-radius: 50%;
  transform: translateY(-0.075em);
  display: grid;
  place-content: center;

  cursor: pointer;
}

input[type='checkbox']::before {
  content: '';
  width: 0.65em;
  height: 0.65em;
  clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
  transform: scale(0);
  transform-origin: bottom left;
  transition: 120ms transform ease-in-out;
  box-shadow: inset 1em 1em var(--form-control-color);
  background-color: #c1cefe;
}

input[type='checkbox']:checked::before {
  transform: scale(1);
}

.important {
  color: #d81159;
}

.completed {
  color: #c1cefe;
  text-decoration: line-through;
}

.description-container {
  background-color: #a0ddff;
  padding: 1rem 2rem;
}

.hide {
  display: none;
}

.chevron-icon-container {
  transition: transform 0.3s ease; /* smooth transition for the flip in class .flip-icon */
}

.flip-icon {
  transform: scaleY(-1); /* vertical flip */
}

.empty {
  text-align: center;
}

#content {
  margin-bottom: 3rem;
}

/*
---------------
Footer
---------------
*/

footer {
  grid-column: span 2;
  padding: 0.5rem;
  text-align: center;

  background-color: #c1cefe;
}

footer a {
  color: #fff;
}

/*
---------------
Forms
---------------
*/

dialog {
  padding: 2rem;

  border-radius: 30px;
  border: none;
  background-color: #7189ff;
  color: #fff;
  box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.4);
}

form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.form-group {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.5rem;
}

form h3 {
  margin-bottom: 1rem;
  font-size: var(--step-2);
  text-align: center;
}

input,
select,
textarea {
  padding: 0.15rem 0.5rem;

  border-radius: 30px;
  border: 3px solid #fff;
}

textarea {
  border-radius: 10px;
}

textarea::-webkit-scrollbar {
  width: 8px;
}

textarea::-webkit-scrollbar-thumb {
  background-color: #c1cefe;
  border-radius: 10px;
}

textarea::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  border-radius: 10px;
}

form input:focus,
select:focus,
textarea:focus {
  border: 3px solid #6439f2;
  outline: none;
}

dialog button {
  justify-self: center;
  padding: 0.5rem 2rem;

  border-radius: 30px;
  border: none;
  cursor: pointer;
}

dialog::backdrop {
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(3px);
}

.submit-todo-btn,
.submit-edit-todo-btn,
.submit-project-btn,
.submit-edit-project-btn,
.cancel-todo-btn,
.cancel-edit-todo-btn,
.cancel-project-btn,
.cancel-edit-project-btn {
  color: #fff;
  box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.4);
}

.submit-todo-btn,
.submit-edit-todo-btn,
.submit-project-btn,
.submit-edit-project-btn {
  margin-top: 2rem;
  background-color: #6439f2;
}

.cancel-todo-btn,
.cancel-edit-todo-btn,
.cancel-project-btn,
.cancel-edit-project-btn {
  background-color: #d81159;
}

.submit-todo-btn:hover,
.submit-edit-todo-btn:hover,
.submit-project-btn:hover,
.submit-edit-project-btn:hover,
.cancel-todo-btn:hover,
.cancel-edit-todo-btn:hover,
.cancel-project-btn:hover,
.cancel-edit-project-btn:hover {
  transform: translateY(-3px);
  cursor: pointer;
}

#edit-todo-current-project,
#edit-current-project {
  background-color: rgb(17, 17, 17);
  border: 3px solid rgb(17, 17, 17);
  color: #fff;
}

form input[type='checkbox'] {
  background-color: #fff;
  border-radius: 8px;
}

form input[type='checkbox']::before {
  background-color: black;
}

/*
---------------
Media Queries
---------------
*/

@media (max-width: 850px) {
  body {
    grid-template-columns: 1fr;
  }

  .main-heading-container {
    justify-content: space-around;
  }

  .project-header {
    gap: 1rem;
  }

  .todo-container {
    grid-template-columns: auto 1fr;
    align-items: center;
    gap: 0.5rem;
    padding: 1rem;
  }

  .date,
  .todo-icons-container {
    grid-column-start: 2;
  }

  .todo-icons-container {
    justify-self: end;
  }

  /* navigation */
  nav {
    /* need this to toggle active class*/
    display: none;

    flex-direction: column;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 999;
    min-height: 100vh;
    min-width: 70%;
    padding-top: 100px;

    box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.4);
  }

  nav.active-nav {
    display: flex;
  }

  .navbar-toggle {
    display: block;
    z-index: 1000;
  }

  /* turn bars into X */
  .navbar-toggle.active-nav .bar:nth-child(2) {
    opacity: 0;
  }

  .navbar-toggle.active-nav .bar:nth-child(1) {
    transform: translateY(8px) rotate(45deg);
    background-color: #d81159;
  }

  .navbar-toggle.active-nav .bar:nth-child(3) {
    transform: translateY(-8px) rotate(-45deg);
    background-color: #d81159;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/styles.css"],"names":[],"mappings":"AAAA;;;;CAIC;;AAED,6CAA6C;AAC7C;;;EAGE,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA,8BAA8B;AAC9B;;;;;EAKE,cAAc;EACd,eAAe;AACjB;;AAEA,uCAAuC;AACvC;;;;EAIE,aAAa;AACf;;AAEA,4BAA4B;AAC5B;;;;;;;EAOE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;AACnB;AACA;;;;;;EAME,kBAAkB;AACpB;;AAEA;;CAEC;AACD;;EAEE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;CAIC;;AAED,wHAAwH;AACxH;EACE,gCAAgC;EAChC,yDAAyD;EACzD,8BAA8B;EAC9B,uDAAuD;EACvD,wBAAwB;EACxB,oDAAoD;EACpD,0BAA0B;EAC1B,wDAAwD;EACxD,8BAA8B;EAC9B,yDAAyD;EACzD,iCAAiC;EACjC,0DAA0D;EAC1D,kCAAkC;EAClC,2DAA2D;EAC3D,kCAAkC;EAClC,2DAA2D;EAC3D,kCAAkC;EAClC,0DAA0D;AAC5D;;AAEA;;;;CAIC;;AAED,kFAAkF;;AAElF;EACE,mCAAmC;EACnC,4DAA8E;EAC9E,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B;mBACiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;CAIC;;AAED;EACE,aAAa;EACb,8BAA8B;EAC9B,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;;EAEhB,wCAAwC;EACxC,wBAAwB;AAC1B;;AAEA,iBAAiB;;AAEjB;EACE,mBAAmB;;EAEnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;;EAEb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,+CAA+C;EAC/C,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;;;;CAIC;;AAED,8BAA8B;;AAE9B;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,gBAAgB;;EAEhB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA,qBAAqB;;AAErB;EACE,aAAa;;EAEb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;;EAEhB,6BAA6B;AAC/B;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;;EAElB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;;;;CAIC;;AAED;EACE,cAAc;EACd,kBAAkB;EAClB,wBAAwB;;EAExB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,qBAAqB;;EAErB,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,SAAS;EACT,kBAAkB;;EAElB,gCAAgC;AAClC;;AAEA;;EAEE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,iCAAiC;EACjC,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,qBAAqB;;EAErB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,uEAAuE;EACvE,mBAAmB;EACnB,6BAA6B;EAC7B,uCAAuC;EACvC,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,+BAA+B,EAAE,uDAAuD;AAC1F;;AAEA;EACE,qBAAqB,EAAE,kBAAkB;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;CAIC;;AAED;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;;EAElB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;;;;CAIC;;AAED;EACE,aAAa;;EAEb,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;;;EAGE,uBAAuB;;EAEvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;;EAGE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;;EAEpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;;;;;;;;EAQE,WAAW;EACX,0CAA0C;AAC5C;;AAEA;;;;EAIE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;;EAEE,iCAAiC;EACjC,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;;CAIC;;AAED;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,+BAA+B;IAC/B,mBAAmB;IACnB,WAAW;IACX,aAAa;EACf;;EAEA;;IAEE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,eAAe;EACf;IACE,oCAAoC;IACpC,aAAa;;IAEb,sBAAsB;IACtB,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,kBAAkB;;IAElB,0CAA0C;EAC5C;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA,qBAAqB;EACrB;IACE,UAAU;EACZ;;EAEA;IACE,wCAAwC;IACxC,yBAAyB;EAC3B;;EAEA;IACE,0CAA0C;IAC1C,yBAAyB;EAC3B;AACF","sourcesContent":["/*\n---------------\nCSS Reset https://www.joshwcomeau.com/css/custom-css-reset/\n---------------\n*/\n\n/* 1. Use a more-intuitive box-sizing model */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n/* 2. Remove default margin */\n*:not(dialog) {\n  margin: 0;\n}\n\n/* 3. Enable keyword animations */\n@media (prefers-reduced-motion: no-preference) {\n  html {\n    interpolate-size: allow-keywords;\n  }\n}\n\nbody {\n  /* 4. Add accessible line-height */\n  line-height: 1.5;\n  /* 5. Improve text rendering */\n  -webkit-font-smoothing: antialiased;\n}\n\n/* 6. Improve media defaults */\nimg,\npicture,\nvideo,\ncanvas,\nsvg {\n  display: block;\n  max-width: 100%;\n}\n\n/* 7. Inherit fonts for form controls */\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\n/* 8. Avoid text overflows */\np,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  overflow-wrap: break-word;\n}\n\n/* 9. Improve line wrapping */\np {\n  text-wrap: pretty;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  text-wrap: balance;\n}\n\n/*\n  10. Create a root stacking context\n*/\n#root,\n#__next {\n  isolation: isolate;\n}\n\nli {\n  list-style-type: none;\n}\n\na {\n  text-decoration: none;\n}\n\n/*\n---------------\nFont size variables\n---------------\n*/\n\n/* @link https://utopia.fyi/type/calculator?c=320,16,1.2,1728,20,1.25,5,2,&s=0.75|0.5|0.25,1.5|2|3|4|6,s-l&g=s,l,xl,12 */\n:root {\n  /* Step -2: 11.1111px → 12.8px */\n  --step--2: clamp(0.6944rem, 0.6705rem + 0.1199vw, 0.8rem);\n  /* Step -1: 13.3333px → 16px */\n  --step--1: clamp(0.8333rem, 0.7955rem + 0.1894vw, 1rem);\n  /* Step 0: 16px → 20px */\n  --step-0: clamp(1rem, 0.9432rem + 0.2841vw, 1.25rem);\n  /* Step 1: 19.2px → 25px */\n  --step-1: clamp(1.2rem, 1.1176rem + 0.4119vw, 1.5625rem);\n  /* Step 2: 23.04px → 31.25px */\n  --step-2: clamp(1.44rem, 1.3234rem + 0.5831vw, 1.9531rem);\n  /* Step 3: 27.648px → 39.0625px */\n  --step-3: clamp(1.728rem, 1.5659rem + 0.8107vw, 2.4414rem);\n  /* Step 4: 33.1776px → 48.8281px */\n  --step-4: clamp(2.0736rem, 1.8513rem + 1.1115vw, 3.0518rem);\n  /* Step 5: 39.8131px → 61.0352px */\n  --step-5: clamp(2.4883rem, 2.1869rem + 1.5072vw, 3.8147rem);\n  /* Step 6: 47.7757px → 76.2939px */\n  --step-6: clamp(2.986rem, 2.5809rem + 2.0254vw, 4.7684rem);\n}\n\n/*\n---------------\nFont\n---------------\n*/\n\n/*! Generated by Font Squirrel (https://www.fontsquirrel.com) on October 7, 2025 */\n\n@font-face {\n  font-family: 'reenie_beanieregular';\n  src: url('../assets/fonts/reeniebeanie-regular-webfont.woff2') format('woff2');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'robotoregular';\n  src: url('../assets/fonts/roboto-variablefont_wdthwght-webfont.woff2')\n    format('woff2');\n  font-weight: normal;\n  font-style: normal;\n}\n\n/*\n---------------\nLayout \n---------------\n*/\n\nbody {\n  display: grid;\n  grid-template-columns: 1fr 3fr;\n  grid-template-rows: auto 1fr auto;\n  min-height: 100vh;\n  max-width: 100vw;\n\n  font-family: 'robotoregular', sans-serif;\n  font-size: var(--step-0);\n}\n\n/* main heading */\n\n.main-heading-container {\n  grid-column: span 2;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 1rem;\n\n  background: #7189ff;\n  box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.4);\n}\n\n.main-heading-and-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem;\n}\n\n.main-heading-container h1 {\n  font-family: 'reenie_beanieregular', sans-serif;\n  font-size: var(--step-6);\n  font-weight: 500;\n  text-align: center;\n}\n\n.main-heading-container .list-icon {\n  width: 100px;\n}\n\n/*\n---------------\nNavigation\n---------------\n*/\n\n/* hamburger on main heading */\n\n.navbar-toggle {\n  display: none;\n  background: transparent;\n  padding: 10px;\n  border: none;\n  cursor: pointer;\n}\n\n.bar {\n  display: block;\n  width: 25px;\n  height: 3px;\n  margin: 5px auto;\n\n  background-color: #111;\n  transition: all 0.3 ease-in-out;\n}\n\n/* nav on left side */\n\nnav {\n  padding: 2rem;\n\n  background: #624cab;\n  color: #fff;\n}\n\nnav h2 {\n  font-size: var(--step-2);\n  font-weight: 500;\n\n  border-bottom: 2px solid #fff;\n}\n\n.add-todo-icon-and-btn,\n.add-project-icon-and-btn {\n  margin: 1.25rem 0;\n}\n\n.add-todo-btn,\n.add-project-btn {\n  font-size: var(--step-1);\n  font-weight: 700;\n}\n\n.nav-project-heading {\n  margin-top: 4rem;\n}\n\nnav .feather-icon {\n  width: 32px;\n  height: 32px;\n}\n\n.feather-icon {\n  cursor: pointer;\n}\n\nnav button {\n  background: transparent;\n  border: none;\n  color: #fff;\n  cursor: pointer;\n}\n\nnav li {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0.25rem 0;\n  padding: 0.5rem 1rem;\n  width: max-content;\n\n  border-radius: 30px;\n}\n\nnav li:hover {\n  background-color: #7189ff;\n  box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.4);\n}\n\n.add-todo-icon-and-btn:hover,\n.add-project-icon-and-btn:hover {\n  background-color: #d81159;\n}\n\n.active-btn-container.active {\n  background-color: #7189ff;\n  box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.4);\n}\n\n/*\n---------------\nTodos Content\n---------------\n*/\n\n.category-heading {\n  margin: 3rem 0;\n  text-align: center;\n  font-size: var(--step-4);\n\n  color: #624cab;\n}\n\n.project-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 2rem;\n  margin: 3rem 0 2rem 0;\n\n  font-family: 'reenie_beanieregular', sans-serif;\n}\n\n.project-heading {\n  font-size: var(--step-4);\n  font-weight: 500;\n}\n\n.todo-container {\n  display: grid;\n  grid-template-columns: auto 1fr auto auto;\n  align-items: center;\n  gap: 2rem;\n  padding: 1rem 2rem;\n\n  border-bottom: 2px solid #a0ddff;\n}\n\n.todo-icons-container,\n.project-header-icons-container {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.completed {\n  color: #c1cefe;\n  text-decoration: line-through;\n}\n\ninput[type='checkbox'] {\n  appearance: none;\n  color: currentColor;\n  width: 1.5em;\n  height: 1.5em;\n  border: 0.15em solid currentColor;\n  border-radius: 50%;\n  transform: translateY(-0.075em);\n  display: grid;\n  place-content: center;\n\n  cursor: pointer;\n}\n\ninput[type='checkbox']::before {\n  content: '';\n  width: 0.65em;\n  height: 0.65em;\n  clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);\n  transform: scale(0);\n  transform-origin: bottom left;\n  transition: 120ms transform ease-in-out;\n  box-shadow: inset 1em 1em var(--form-control-color);\n  background-color: #c1cefe;\n}\n\ninput[type='checkbox']:checked::before {\n  transform: scale(1);\n}\n\n.important {\n  color: #d81159;\n}\n\n.completed {\n  color: #c1cefe;\n  text-decoration: line-through;\n}\n\n.description-container {\n  background-color: #a0ddff;\n  padding: 1rem 2rem;\n}\n\n.hide {\n  display: none;\n}\n\n.chevron-icon-container {\n  transition: transform 0.3s ease; /* smooth transition for the flip in class .flip-icon */\n}\n\n.flip-icon {\n  transform: scaleY(-1); /* vertical flip */\n}\n\n.empty {\n  text-align: center;\n}\n\n#content {\n  margin-bottom: 3rem;\n}\n\n/*\n---------------\nFooter\n---------------\n*/\n\nfooter {\n  grid-column: span 2;\n  padding: 0.5rem;\n  text-align: center;\n\n  background-color: #c1cefe;\n}\n\nfooter a {\n  color: #fff;\n}\n\n/*\n---------------\nForms\n---------------\n*/\n\ndialog {\n  padding: 2rem;\n\n  border-radius: 30px;\n  border: none;\n  background-color: #7189ff;\n  color: #fff;\n  box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.4);\n}\n\nform {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.form-group {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 0.5rem;\n}\n\nform h3 {\n  margin-bottom: 1rem;\n  font-size: var(--step-2);\n  text-align: center;\n}\n\ninput,\nselect,\ntextarea {\n  padding: 0.15rem 0.5rem;\n\n  border-radius: 30px;\n  border: 3px solid #fff;\n}\n\ntextarea {\n  border-radius: 10px;\n}\n\ntextarea::-webkit-scrollbar {\n  width: 8px;\n}\n\ntextarea::-webkit-scrollbar-thumb {\n  background-color: #c1cefe;\n  border-radius: 10px;\n}\n\ntextarea::-webkit-scrollbar-track {\n  background-color: #f1f1f1;\n  border-radius: 10px;\n}\n\nform input:focus,\nselect:focus,\ntextarea:focus {\n  border: 3px solid #6439f2;\n  outline: none;\n}\n\ndialog button {\n  justify-self: center;\n  padding: 0.5rem 2rem;\n\n  border-radius: 30px;\n  border: none;\n  cursor: pointer;\n}\n\ndialog::backdrop {\n  background-color: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(3px);\n}\n\n.submit-todo-btn,\n.submit-edit-todo-btn,\n.submit-project-btn,\n.submit-edit-project-btn,\n.cancel-todo-btn,\n.cancel-edit-todo-btn,\n.cancel-project-btn,\n.cancel-edit-project-btn {\n  color: #fff;\n  box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.4);\n}\n\n.submit-todo-btn,\n.submit-edit-todo-btn,\n.submit-project-btn,\n.submit-edit-project-btn {\n  margin-top: 2rem;\n  background-color: #6439f2;\n}\n\n.cancel-todo-btn,\n.cancel-edit-todo-btn,\n.cancel-project-btn,\n.cancel-edit-project-btn {\n  background-color: #d81159;\n}\n\n.submit-todo-btn:hover,\n.submit-edit-todo-btn:hover,\n.submit-project-btn:hover,\n.submit-edit-project-btn:hover,\n.cancel-todo-btn:hover,\n.cancel-edit-todo-btn:hover,\n.cancel-project-btn:hover,\n.cancel-edit-project-btn:hover {\n  transform: translateY(-3px);\n  cursor: pointer;\n}\n\n#edit-todo-current-project,\n#edit-current-project {\n  background-color: rgb(17, 17, 17);\n  border: 3px solid rgb(17, 17, 17);\n  color: #fff;\n}\n\nform input[type='checkbox'] {\n  background-color: #fff;\n  border-radius: 8px;\n}\n\nform input[type='checkbox']::before {\n  background-color: black;\n}\n\n/*\n---------------\nMedia Queries\n---------------\n*/\n\n@media (max-width: 850px) {\n  body {\n    grid-template-columns: 1fr;\n  }\n\n  .main-heading-container {\n    justify-content: space-around;\n  }\n\n  .project-header {\n    gap: 1rem;\n  }\n\n  .todo-container {\n    grid-template-columns: auto 1fr;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 1rem;\n  }\n\n  .date,\n  .todo-icons-container {\n    grid-column-start: 2;\n  }\n\n  .todo-icons-container {\n    justify-self: end;\n  }\n\n  /* navigation */\n  nav {\n    /* need this to toggle active class*/\n    display: none;\n\n    flex-direction: column;\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 999;\n    min-height: 100vh;\n    min-width: 70%;\n    padding-top: 100px;\n\n    box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.4);\n  }\n\n  nav.active-nav {\n    display: flex;\n  }\n\n  .navbar-toggle {\n    display: block;\n    z-index: 1000;\n  }\n\n  /* turn bars into X */\n  .navbar-toggle.active-nav .bar:nth-child(2) {\n    opacity: 0;\n  }\n\n  .navbar-toggle.active-nav .bar:nth-child(1) {\n    transform: translateY(8px) rotate(45deg);\n    background-color: #d81159;\n  }\n\n  .navbar-toggle.active-nav .bar:nth-child(3) {\n    transform: translateY(-8px) rotate(-45deg);\n    background-color: #d81159;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
